import { render, staticRenderFns } from "./OurDataField.vue?vue&type=template&id=5af69030&"
import script from "./OurDataField.vue?vue&type=script&lang=js&"
export * from "./OurDataField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports